import { SVGProps, Ref, forwardRef } from 'react';

export const MoonStarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.708 1.125C7.395-.357 6.328 1 6.016 3.09l-.046.386c-.349 3.83 2.724 6.903 6.554 6.555l.386-.046c2.09-.312 3.448-1.379 1.966 1.307l-.13.227c-1.371 2.322-3.78 3.981-6.662 3.981A7.584 7.584 0 0 1 .5 7.916c0-2.882 1.66-5.29 3.98-6.662zM4.642 2.82C3.042 3.965 1.978 5.7 1.904 7.694l-.004.222A6.184 6.184 0 0 0 8.084 14.1c2.085 0 3.91-1.083 5.098-2.742l-.065.011c-5.067.758-9.244-3.418-8.486-8.486z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MoonStarOutlinedSize16Glyph.displayName = 'MoonStarOutlinedSize16Glyph';
